import React from 'react'
import ReactDOM from 'react-dom'

import { AppEntry } from './ui/app'

ReactDOM.render(<AppEntry />, document.querySelector('#root'))
